import { render, staticRenderFns } from "./PosTableDetailBuffet.vue?vue&type=template&id=3dc7a393&scoped=true&"
import script from "./PosTableDetailBuffet.vue?vue&type=script&lang=js&"
export * from "./PosTableDetailBuffet.vue?vue&type=script&lang=js&"
import style0 from "./PosTableDetailBuffet.vue?vue&type=style&index=0&id=3dc7a393&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dc7a393",
  null
  
)

export default component.exports